import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import {isSessionSupervisor} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import Spinner from 'components/spinner';
import SupervisorHome from './supervisor-home';
import OrganizationHome from './organization-home';

@graphql(userQuery, {name: 'userData'})
export default class Home extends Component {
    render() {
        if (this.props.userData.loading) return <Spinner />;
        if (isSessionSupervisor(this.props.userData.user)) return <SupervisorHome user={this.props.userData.user} location={this.props.location}/>;
        return <OrganizationHome user={this.props.userData.user} />;
    }
}



// WEBPACK FOOTER //
// ./views/home/index.js